import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    // Add noindex meta tag for 404 page
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);

    document.title = isRTL ? 'الصفحة غير موجودة - إيف سمارت' : 'Page Not Found - EVE Smart';

    return () => {
      document.head.removeChild(metaRobots);
    };
  }, [isRTL]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 to-white px-6">
      <div className={`text-center ${isRTL ? 'font-almarai' : ''}`}>
        <div className="mb-8">
          <i className="ri-error-warning-line text-8xl text-primary"></i>
        </div>
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-2xl text-gray-600 mb-8">
          {isRTL ? 'الصفحة غير موجودة' : 'Page Not Found'}
        </p>
        <button
          onClick={() => navigate('/')}
          className="bg-primary text-white px-8 py-4 rounded-full font-tajawal text-base hover:bg-primary-dark transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
        >
          {isRTL ? 'العودة للرئيسية' : 'Back to Home'}
          <i className={`ri-arrow-${isRTL ? 'left' : 'right'}-line`}></i>
        </button>
      </div>
    </div>
  );
};

export default NotFound;
